import { UserRoles } from '@models/user.model';
import { getAssignableRoles } from '@constants/roleHierarchy';

export const USER_ROLES = [
  {
    id: 'ADMIN',
    name: 'Admin',
  },
  {
    id: 'PROJECT_MANAGER',
    name: 'Project Manager',
  },
  {
    id: 'SUPERINTENDENT',
    name: 'Superintendent',
  },
  {
    id: 'CREW_LEAD',
    name: 'Crew Lead',
  },
  {
    id: 'EMPLOYEE',
    name: 'Employee',
  },
  {
    id: 'REVIEWER',
    name: 'Reviewer',
  },
];

export const USER_TYPE_OPTIONS = [
  { value: UserRoles.ADMIN, label: 'Admin' },
  { value: UserRoles.PROJECT_MANAGER, label: 'Project Manager' },
  { value: UserRoles.SUPERINTENDENT, label: 'Superintendent' },
  { value: UserRoles.CREW_LEAD, label: 'Crew Lead' },
  { value: UserRoles.EMPLOYEE, label: 'Employee' },
  { value: UserRoles.REVIEWER, label: 'Reviewer' },
];

// Sidebar role tabs the given user may browse: their own level and below.
// Preserves USER_ROLES order (which is descending rank).
export const getVisibleUserRoleTabs = (actorRole?: string | null) => {
  const assignable = getAssignableRoles(actorRole);
  return USER_ROLES.filter((role) => assignable.includes(role.id));
};

// Role dropdown options the given user may assign.
export const getRoleTypeOptions = (actorRole?: string | null) => {
  const assignable = getAssignableRoles(actorRole);
  return USER_TYPE_OPTIONS.filter((option) => assignable.includes(option.value));
};

export enum UserType {
  ADMIN = 'Admin',
  PROJECT_MANAGER = 'Project Manager',
  SUPERINTENDENT = 'Superintendent',
  CREW_LEAD = 'Crew Lead',
  EMPLOYEE = 'Employee',
  REVIEWER = 'Reviewer',
  // Sprint 25, story-128 (run 5). CLIENT never appears in `USER_ROLES`/`USER_TYPE_OPTIONS`
  // (it isn't assignable through the Users tab — the Client entity is the source of truth, per
  // the UX doc), but a CLIENT membership can still be READ on this page (e.g. a SUPER_ADMIN
  // browsing memberships, or a future org-scoped view), so `UserCard`'s
  // `UserType[role as keyof typeof UserType]` lookup needs an entry to avoid rendering
  // `undefined`.
  CLIENT = 'Client',
}

export const PAY_PERIOD_OPTIONS = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
];

export const MODE_OPTIONS = [
  { value: 'FULL_TIME', label: 'Full-time' },
  { value: 'PART_TIME', label: 'Part-time' },
];

export enum PayPeriod {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}

export enum Mode {
  FULL_TIME = 'Full-time',
  PART_TIME = 'Part-time',
}
